import React, { Component } from "react";
import { View, Text } from "react-native";
import chatstyles from "../styles/chatStyles";
import { LinearGradient } from "expo-linear-gradient";

class SystemMessages extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  // on load page.
  componentDidMount() {}
  render() {
    return (
      <View style={[chatstyles.agentTransfer, chatstyles.tranferedToAgent]}>
        <Text
          style={[chatstyles.agentConnectedText, chatstyles.width100Percent]}
        >
          {this.props.message}
        </Text>
      </View>
    );
  }
}
export default SystemMessages;
